import i18n from "@/i18n";

const typeVariants = [
  { id: "shippable", name: i18n.t("integrations.ofr.type.shippable") },
  { id: "non_shippable", name: i18n.t("integrations.ofr.type.non_shippable") }
];

export { typeVariants };
